<script setup>
import { currency } from '~/ui/vue/filters'
const showNotification = inject('showNotification')

const props = defineProps({
  action: {
    type: Object,
    required: true
  },
  data: {
    type: Object,
    required: true
  }
})

const loading = ref(false)
const vin = computed(() => props.data.vehicle.vin)
const price = computed(() => currency(props.data.acvValues.guarantee))

const emit = defineEmits(['close'])

const acceptOffer = async () => {
  loading.value = true

  const input = {
    updateOfferStateInput: {
      vin: props.data.vehicle.vin,
      inventoryId: props.data.id,
      state: 'OfferAccepted',
      price: props.data.acvValues.guarantee
    }
  }

  try {
    const response = await props.action.fetch(input)
    const offerAccepted = response.data.updateOfferState
    emit('close', offerAccepted)
  } catch {
    showNotification('Failed to accept the offer.')
  } finally {
    loading.value = false
  }
}

const cancelAction = () => {
  emit('close')
  props.action.abort()
}
</script>

<template>
  <VCard class="rounded-xl">
    <VCardTitle class="text-h6">
      Accept ACV Guarantee Offer
    </VCardTitle>

    <VCardText class="text-body-2">
      Do you want to accept the ACV Guarantee of {{ price }} for this vehicle {{ vin }}?
    </VCardText>

    <VCardActions class="pa-4 pt-0">
      <VSpacer />
      <VBtn
        color="primary"
        variant="tonal"
        class="rounded-pill px-4"
        @click="cancelAction"
      >
        Cancel
      </VBtn>
      <VBtn
        color="primary"
        variant="flat"
        :loading="loading"
        class="rounded-pill px-4"
        @click="acceptOffer"
      >
        Yes, Accept Offer
      </VBtn>
    </VCardActions>
  </VCard>
</template>
